import { Typography } from "antd/lib";
import * as React from "react";
import { useMemo } from "react";
import classNames from "classnames";
import { formatPercent } from "@/helpers";

export const PercentChange = ({
  change,
  isFullPercent,
  subPrefix,
  className,
  style,
  isCustom = false,
}: {
  change?: number;
  isFullPercent?: boolean;
  subPrefix?: string;
  className?: string;
  style?: React.CSSProperties;
  isCustom?: boolean;
}) => {
  const percent = useMemo(
    () => (change !== null && change !== undefined ? change * (isFullPercent ? 1 : 100) : 0),
    [change, isFullPercent],
  );
  const stringValue = useMemo(
    () => (isCustom && +formatPercent(Math.abs(percent)) === 0 ? "<0.01" : formatPercent(Math.abs(percent))),
    [isCustom, percent],
  );
  const isNoChange = useMemo(() => stringValue === "0" || change === null, [change, stringValue]);

  return (
    <Typography.Text
      type={
        percent === 0 || isNoChange
          ? "secondary"
          : percent > 0 && !isNoChange
          ? "success"
          : percent < 0 && !isNoChange
          ? "danger"
          : undefined
      }
      style={style}
      className={classNames("inline-flex whitespace-nowrap", className)}
      title={percent.toString()}
    >
      {percent > 0 && !isNoChange && "+"}
      {percent < 0 && !isNoChange && "-"}
      {change === null ? "-" : `${stringValue}${subPrefix ?? "%"}`}
    </Typography.Text>
  );
};
